import { Box, Typography, Grid2 } from '@mui/material';
import parse from 'html-react-parser';
import { FormPublicDesignFragment } from 'graphql/fragment/form.public.fragment';
import Image from 'next/image';
import turtle from '../assets/turtle.svg';
import chart from '../assets/chart.svg';
import target from '../assets/target.svg';
import map from '../assets/map.svg';
import { Instruction } from '../new-start-page';

interface Props {
  design: FormPublicDesignFragment;
  instructions: Instruction[];
}
const instructionImages = {
  turtle: turtle,
  chart: chart,
  target: target,
  map: map,
};

const InstructionsGrid = ({ design, instructions }: Props) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: '30px',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridTemplateRows: 'repeat(2, 1fr)',
        width: '100%',
      }}
    >
      {instructions.map((instruction) => (
        <Box
          sx={{
            display: 'flex',
            flex: '1 0 50%',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <Image
            src={instruction.image}
            alt={`${instruction.image}`}
            width={40}
            height={40}
          ></Image>
          <Box>
            <Typography
              style={{
                color: design.colors.question,
                fontSize: '18px',
                fontWeight: '400',
              }}
            >
              {instruction.title}
            </Typography>
            <Typography
              style={{
                color: design.colors.question,
                fontSize: '18px',
                fontWeight: '400',
              }}
            >
              {parse(instruction.text)}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default InstructionsGrid;
